@if (!loading()) {
  <div class="td-wb-w8ben-form-preview">
    @if (profile() && requiredFieldMissing()) {
      <td-wb-notification notificationType="info"
                          class="td-wb-w8ben-form-preview__notification">
        <span translate="tdWb.w8BenForm.modal.preview.citizenship.MESSAGE_I"></span>
        <a id="td-wb-w8ben-form-preview-download-link"
          tdWbHref="link_w8ben_form_pdf"
          target="blank">
          <span translate="tdWb.w8BenForm.modal.preview.citizenship.MESSAGE_II"></span>
        </a>
        <span translate="tdWb.w8BenForm.modal.preview.citizenship.MESSAGE_III"></span>
      </td-wb-notification>
    } @else {
      <div class="td-wb-w8ben-form-preview__header">
        <div class="td-wb-w8ben-form-preview__header-icon">
          <img alt=""
                src="assets/core/illustrations/agreements--not-signed.svg"
                width="150"
                height="73.43"/>
        </div>
        <h2 class="td-wb-w8ben-form-preview__header-title">
            <span [attr.id]="getModalId()"
                  translate="tdWb.w8BenForm.modal.preview.TITLE"></span>
          </h2>
        <div class="td-wb-w8ben-form-preview__header-text">
          <div translate="tdWb.w8BenForm.modal.preview.TITLE_TEXT"></div>
        </div>
      </div>
      <div class="td-wb-w8ben-form-preview__info">
        @if (profile()) {
          <div class="td-wb-w8ben-form-preview__info-title">
              <span id="td-wb-w8ben-form-preview-info-content"
                    translate="tdWb.w8BenForm.modal.preview.INFO_TITLE"></span>
          </div>

          @if (addressMissing()) {
            <td-wb-notification notificationType="warning"
                                class="td-wb-w8ben-form-preview__notification">
              <span translate="tdWb.w8BenForm.modal.preview.addressMissing.MESSAGE"></span>
            </td-wb-notification>
          }
        }

        <td-wb-divider />

        @if (profile(); as profile) {
          <div class="td-wb-w8ben-form-preview__info-content">
            <dl aria-labelledby="td-wb-w8ben-form-preview-info-content">
              <dt><span translate="tdWb.w8BenForm.modal.preview.LEGAL_NAME_LABEL"></span></dt>
              <dd [innerText]="profile.legalName"></dd>
              <dt><span translate="tdWb.w8BenForm.modal.preview.DATE_BIRTH_LABEL"></span></dt>
              <dd [innerText]="profile.birthDt"></dd>
              <dt><span translate="tdWb.w8BenForm.modal.preview.CITIZENSHIP_LABEL"></span></dt>
              <dd [innerText]="profile.citizenship"></dd>
              <dt><span translate="tdWb.w8BenForm.modal.preview.SIN_LABEL"></span></dt>
              @if (showSin()) {
                <dd [innerText]="getSin()"></dd>
              } @else if (profile.ftinNotRequired) {
                <dd>
                  <span translate="tdWb.w8BenForm.modal.preview.NOT_APPLICABLE"></span>
                </dd>
              } @else {
                <dd>
                  <span translate="tdWb.w8BenForm.modal.preview.NOT_AVAILABLE"></span>
                </dd>
              }
            </dl>
            <dl aria-labelledby="td-wb-w8ben-form-preview-info-content">
              <dt><span translate="tdWb.w8BenForm.modal.preview.RESIDENCE_ADDRESS_LABEL"></span></dt>
              <dd>
                @if (addressMissing()) {
                  <span>-</span>
                } @else {
                  @for (addressLine of profile.residenceAddressLines; track $index) {
                    <span [innerText]="addressLine"></span><br>
                  }
                }
              </dd>
              <dt><span translate="tdWb.w8BenForm.modal.preview.MAILING_ADDRESS_LABEL"></span></dt>
              @if (profile.mailingAddressLines) {
                <dd>
                  @for (addressLine of profile.mailingAddressLines; track $index) {
                    <span [innerText]="addressLine"></span><br>
                  }
                </dd>
              } @else {
                <dd>
                  <span translate="tdWb.w8BenForm.modal.preview.NOT_AVAILABLE"></span>
                </dd>
              }
            </dl>
          </div>
        } @else {
          <div class="td-wb-w8ben-form-preview__error">
            <td-wb-w8ben-form-error />
          </div>
        }
        </div>
        @if (profile()) {
          <div class="td-wb-w8ben-form-preview__actions">
            <td-wb-divider />
            <div class="td-wb-w8ben-form-preview__actions-buttons">
              @if (addressMissing()) {
                <button tdWbButton
                        (click)="onClickUpdate()">
                  <span translate="tdWb.w8BenForm.modal.preview.addressMissing.BUTTON_TEXT"></span>
                </button>
              } @else {
                <button tdWbButton
                        tdWbButtonType="secondary"
                        (click)="onClickUpdate()">
                  <span translate="tdWb.w8BenForm.modal.preview.BUTTON_UPDATE_TEXT"></span>
                </button>
                <button tdWbButton
                        (click)="onClickConfirm()">
                  <span translate="tdWb.w8BenForm.modal.preview.BUTTON_CONFIRM_TEXT"></span>
                </button>
              }
            </div>
          </div>
        }
    }
  </div>
} @else {
  <td-wb-detailed-loading-indicator />
}
